export default __webpack_public_path__ + "static/media/kitchen5-beforeD-768w.9bbb10d1.png";